<mat-vertical-stepper linear #stepper>
  <ng-template matStepperIcon="number" let-index="index">
    <sn-icon size="xs" *ngIf="passwordIsCreated" class="mat-step-icon-content">done_all</sn-icon>
    <span *ngIf="!passwordIsCreated" class="mat-step-icon-content">{{ index + 1 }}</span>
  </ng-template>

  <mat-step [editable]="false" [completed]="emailIsConfirmed">
    <ng-template matStepLabel>{{ emailConfirm.label }}</ng-template>
    <sn-auth-confirm-email
      #emailConfirm
      [uid]="uid"
      [token]="token"
      (confirm)="onEmailConfirmed($event)"
    >
    </sn-auth-confirm-email>
  </mat-step>

  <mat-step *ngIf="phoneConfirmationRequired" [editable]="false" [completed]="phoneIsConfirmed">
    <ng-template matStepLabel>{{ phoneConfirm.label }}</ng-template>
    <sn-auth-confirm-phone #phoneConfirm (confirmed)="onPhoneConfirmed()"></sn-auth-confirm-phone>
  </mat-step>

  <mat-step *ngIf="!passwordWasAlreadyCreated" [editable]="false" [completed]="passwordIsCreated">
    <ng-template matStepLabel>{{ createPassword.label }}</ng-template>
    <sn-auth-create-password
      #createPassword
      (created)="onPasswordCreated()"
      (serverError)="serverError.next($event)"
    ></sn-auth-create-password>
  </mat-step>

  <mat-step label="Done" [editable]="false" [completed]="passwordIsCreated">
    <sn-alert type="success" class="auth-mb-none" *ngIf="passwordIsCreated">
      <b>Your account has been activated.</b>
      You'll be redirected to <a href="" (click)="completeConfirmation()">login page</a> after {{
      redirectTimer$ | async }} sec …
    </sn-alert>
  </mat-step>
</mat-vertical-stepper>
